module.exports = __webpack_public_path__ + "img/hrv2021.526bad82.png";